function clone(item:any){
    return JSON.parse(JSON.stringify(item))
}
export default clone
